export default function TopNavbar() {
    return (
        <div className="navbar flex justify-center">
            <div className="navbar-center lg:flex">
                <ul className="menu menu-horizontal px-1">
                    <li>
                        <a href={route('object_storage.index')}>
                            Object storage
                        </a>
                    </li>
                    <li>
                        <a href={route('upstash.index')}>Upstash</a>
                    </li>
                    <li>
                        <a href={route('cloudflare.index')}>Cloudflare</a>
                    </li>
                </ul>
            </div>
        </div>
    );
}
